{
  "title": "Returns",
  "subtitle": "Record stock returned from customers or sent back to suppliers.",
  "add": "New Return",
  "edit": "Edit",
  "post": "Post",
  "table": {
    "number": "Return #",
    "type": "Type",
    "warehouse": "Warehouse",
    "date": "Date",
    "lines": "Lines",
    "status": "Status"
  },
  "form": {
    "warehouse": "Warehouse",
    "returnType": "Return Type",
    "fromCustomer": "From Customer",
    "toSupplier": "To Supplier",
    "customer": "Customer",
    "supplier": "Supplier",
    "none": "None",
    "material": "Material",
    "quantity": "Quantity",
    "reason": "Reason",
    "client": "Client",
    "clientHintNewBatch": "Only needed for a new/unbatched item — an existing batch resolves its own client automatically.",
    "addLine": "Add Line"
  },
  "save": "Save",
  "cancel": "Cancel"
}
